// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top: 6px solid red;\n}\n\n.modal-dialog {\n  background-color: #fff;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem 0.5rem;\n  text-align: left;\n}\n\n.modal-button {\n  background-color: var(--clickable-color);\n}", ""]);
// Exports
module.exports = exports;
